import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[boschUiHeaderCellDef]',
  standalone: false,
})
export class BoschUiHeaderCellDefDirective<DataType> {
  public readonly templateRef = inject(TemplateRef<DataType>);
}
